import { commentsItems } from '@/mocks/anime';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            漫友热评
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            来自真实用户的使用反馈与推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {commentsItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 border-2 border-primary-100">
                  <img
                    src={item.avatar}
                    alt={item.user}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{item.user}</div>
                  <div className="text-xs text-foreground-500">{item.date}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5 flex-shrink-0">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-secondary-400 text-xs"></i>
                    </div>
                  ))}
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}